import { useEffect, useState } from 'react'
import performanceReportsApi from 'services/api/performanceReports'

export const useMonthlyRevenueData = ({
  firstYear,
  secondYear,
  showWholeGroup,
  showAllHotels,
  parentChain,
  dataToShow,
  cityToFilter,
  stateToFilter,
  groupToFilter
}) => {
  const [isLoading, setIsLoading] = useState(true)
  const [isFetching, setIsFetching] = useState(false)
  const [isErred, setIsErred] = useState(false)
  const [errorText, setErrorText] = useState('')
  const [response, setResponse] = useState()
  const [groupHotelData, setGroupHotelData] = useState()
  const [groupName, setGroupName] = useState()
  const [hotelGroups, setHotelGroups] = useState()
  const [availableCities, setAvailableCities] = useState()
  const [cumulativeData, setCumulativeData] = useState()
  const [minimumAvailableYear, setMinimumAvailableYear] = useState()

  useEffect(() => {
    if (firstYear && !secondYear) {
      return
    }

    setIsFetching(true)

    let kind = 'CurrentSubsidiary'
    if (showWholeGroup) kind = 'WholeGroup'
    if (showAllHotels) kind = 'AllSubsidiaries'

    performanceReportsApi
      .montlyBookings({
        firstYear,
        secondYear,
        kind,
        parentChainCode: parentChain,
        bookingFilterKind: dataToShow,
        city: cityToFilter,
        groupId: groupToFilter,
        stateCode: stateToFilter
      })
      .then(response => {
        setResponse(response)
        setMinimumAvailableYear(response.minimumAvailableYear)
        setGroupName(response.hotelName)
        setGroupHotelData(response.subsidiaries)
        setAvailableCities(response.cities)
        setCumulativeData(response.cumulative)
        setHotelGroups(
          response.hotelGroups.reduce((acc, hotelGroup) => {
            return { ...acc, [hotelGroup.id]: hotelGroup.name }
          }, {})
        )
        setIsErred(false)
      })
      .catch(err => {
        setIsErred(true)
        setCumulativeData()
        setGroupHotelData()
        setErrorText(getErrorMessage(err))
      })
      .finally(() => {
        setIsLoading(false)
        setIsFetching(false)
      })
  }, [
    firstYear,
    secondYear,
    showWholeGroup,
    parentChain,
    dataToShow,
    showAllHotels,
    cityToFilter,
    stateToFilter,
    groupToFilter
  ])

  return {
    isLoading,
    isFetching,
    isErred,
    errorText,
    response,
    groupHotelData,
    groupName,
    hotelGroups,
    availableCities,
    cumulativeData,
    minimumAvailableYear
  }
}

const getErrorMessage = err => {
  if (err.toString().includes('Too many hotels to list')) {
    return 'Too many hotels to list. Use more filters.'
  }
  if (err.toString().includes('Location not found')) {
    return 'No hotels found with these filters.'
  }
  return 'Something went wrong'
}

export default useMonthlyRevenueData
